/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Modern_Keyboard_HandlingInputs */

const en_mobile_modern_keyboard_handling = /** @type {(inputs: Mobile_Modern_Keyboard_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern keyboard handling`)
};

const es_mobile_modern_keyboard_handling = /** @type {(inputs: Mobile_Modern_Keyboard_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manejo de teclado moderno`)
};

/**
* | output |
* | --- |
* | "Modern keyboard handling" |
*
* @param {Mobile_Modern_Keyboard_HandlingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_modern_keyboard_handling = /** @type {((inputs?: Mobile_Modern_Keyboard_HandlingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Modern_Keyboard_HandlingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_modern_keyboard_handling(inputs)
	return en_mobile_modern_keyboard_handling(inputs)
});